<template>
  <section class="dan_alix_sec">
    <h3 class="dan_alix_quotes" v-html="shopifyData.quote" />
    <span class="dan_alix_author" v-html="shopifyData.quotes_writer" />
  </section>
</template>

<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.dan_alix_sec {
  margin: 100px 5%;
}

.dan_alix_quotes {
  font-size: 72px;
  margin-bottom: 15px;
  color: #ff0000;
  font-family: 'Helvetica', sans-serif;
  line-height: 1;
  display: inline;
}

.dan_alix_author {
  color: #000000;
  font-size: 20px;
  font-family: 'Helvetica', sans-serif;
  font-weight: 700;
  margin-left: 20px;
  display: inline-block;
}

@media only screen and (max-width: 768px) {
  .dan_alix_quotes {
    font-size: 48px;
  }

  .dan_alix_sec {
    margin: 80px 5%;
  }

  .dan_alix_author {
    font-size: 18px;
  }
}
</style>
